import React, { useState, useEffect } from 'react'
import {useHistory} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'

import DashboardHeader from './dashboardHeader'
import DashBoardContainer from '../../components/containers/dashboardContainer'
import HorizontalTextinput from '../../components/horizontalTextinput'
import DragAndDrop from '../../components/dragAndDrop/fileUpload'
import CountrySelector from '../../components/countrySelector/countrySelector'
import DatePicker from '../../components/datePicker/datePicker'
import { 
    submitIndividualApplication,
    updateIndividualApplication,
    fetchIndividualApplication,
    fetchFile,
    fetchIndividualApplicationReport,
    editMembership
 } from '../../actions'
import {  
    SUBMIT_APPLICATION_ID,
    EDIT_MEMBERSHIP_LOADING_ID

 } from '../../store/loaders'
import moment  from 'moment'
import { v4 as uuidv4 } from 'uuid'
import PopupModel from '../../components/models/popupModel'





const ApplicationCertificationDetails = (props)=>{
    const history = useHistory()
    const dispatch = useDispatch()

    const apiResponse = useSelector(state=>{
        const {loader,
            individualApplication,
            hasUpdatedIndividualApplication,
            fetchFile,
            individualApplicationReport,
            hasEditedMembership
        } = state
        const {isLoading} = loader[SUBMIT_APPLICATION_ID] || {isLoading: false}
        const {application} = individualApplicationReport
        const {message} = hasUpdatedIndividualApplication
        const {file} = fetchFile
        const {edited} = hasEditedMembership
        const editLoader = loader[EDIT_MEMBERSHIP_LOADING_ID] || false

        return{
            isLoading,
            application,
            message,
            file,
            edited,
            editLoader
        }
    })


    const actionLoader = apiResponse.isLoading
    const applicationId = apiResponse.application?.applicationId || apiResponse.application?.id
    const appId = props.location.state && props.location.state.application?.id
    const isMember = props.location.state && props.location.state?.isMember



    const [hasDownloaded, setHasDownloaded] = useState(false)
    const [download, setDownload] = useState(false)
    const [fileModel, showFileModel] = useState(false)



    const [certificateName, 
        setCertificateName] = useState('')
    const [provider, 
        setProvider] = useState('')
    const [location, 
        setLocation] = useState('')
    const [newUserInfo, 
        setNewUserInfo] = useState('');
    const [startDate, 
        setStartDate] = useState(null)
    const [endDate,
        setEndDate] = useState(null)

    const [newCertificateArr, 
        setNewCertificateArr] = useState([])
    const [requestId, 
        setRequestId] = useState('')

    const [files, 
        setFiles] = useState({});

    const [applicationDetails,
            setApplicationDetails] = useState({})

    const [showItems, setItems] = useState(true)
    const [addBtn, setAddBtn] = useState(true)

    const [hasUploaded, setHasUploaded] = useState(true)

    
    useEffect(()=>{
        if(isMember){
            setApplicationDetails(props.location.state.application)
            if(props.location.state.application && props.location.state.application?.professionalCertificates?.length > 0){
                setNewCertificateArr(props.location.state.application?.professionalCertificates)
                setItems(false)
            }
        }
    },[])


    useEffect(()=>{
        if(apiResponse.edited === requestId){
        history.push({
            pathname: '/membership',
            state: {
                // application: applicationDetails
            }
        })
        }
    },[apiResponse.edited])

    useEffect(()=>{
        if(apiResponse.file?.fileText != null && !hasDownloaded && download){
            var a = document.createElement("a");
            a.href =  "data:image/" +apiResponse.file?.type +";base64," + apiResponse.file?.fileText; 
            a.download = apiResponse.file?.name || 'File' + "." + apiResponse.file?.type || ''; 
            a.click();
            setHasDownloaded(true)
        }
    },[apiResponse.file])

    useEffect(()=>{
        if(!isMember){
            dispatch(fetchIndividualApplicationReport(appId))
        }
        if(apiResponse.message === requestId){
            history.push('/dashboard')
        }
    },[apiResponse.message])

    useEffect(()=>{
        if(!isMember){
            if(apiResponse.application){
                setApplicationDetails({
                    ...apiResponse.application
                })
                setItems(false)
            }
        }
        if(apiResponse.application?.professionalCertificates?.length > 0){
            setNewCertificateArr(apiResponse.application.professionalCertificates)
        }
    },[apiResponse.application])



    const handleCertificateName = (text)=>{
        setCertificateName(text.target.value)
    }
    const handleProvider = (text)=>{
        setProvider(text.target.value)
    }
    const handleLocation = (text)=>{
        setLocation(text)
    }
    
    const handleStartdate = (text)=>{
        setStartDate(text)
    }
    const handleEndDate = (text)=>{
        setEndDate(text)
    }
    const updateUploadedFiles = (files) =>{
        setNewUserInfo(files);
    }


    const handleRemoveItem = (id)=>{
        var deletedItem 
        deletedItem = newCertificateArr.filter(function(el,index){
            return index !== id
        })
        setNewCertificateArr(deletedItem)
    }

    const downloadFile = (value)=>{
        if(value.certificateDocumentFile?.changed){
            var a = document.createElement("a");
            a.href =  "data:image/" +value.certificateDocumentFile?.type +";base64," + value.certificateDocumentFile?.fileText; 
            a.download = value.certificateDocumentFile?.name; 
            a.click();
            return
        }
        let url  
        if(value?.certificateDocumentFile?.fileText !== '' && value?.certificateDocumentFile?.fileText !== undefined ){
            url = encodeURIComponent(value.certificateDocumentFile?.fileText.substring(value.certificateDocumentFile?.fileText.indexOf("/tmp"), value.certificateDocumentFile?.fileText.length))
            dispatch(fetchFile(url))
        }
        setDownload(true)
        setHasDownloaded(false)
    }

    const handleShowItems = ()=>{
        setItems(true)
        setAddBtn(false)
    }

    var displayNewArr 
    if(newCertificateArr.length>0){
        displayNewArr = newCertificateArr.map((value, id)=>{            
            return(
                <div className="dashboarder-grey-contanier mt-4 mb-4" style={{flexDirection: 'column'}}>
                    <div style={{width: '100%', display: 'flex'}}>
                        <div style={{width: '18%'}}>
                                <HorizontalTextinput 
                                    title="Certificate name"
                                    disabled={true}
                                    value={value.name || value.certificateName}
                                    />
                            </div>
                            <div style={{width: '18%'}}>
                                <HorizontalTextinput 
                                    title="Provider"
                                    disabled={true}
                                    value={value.provider}
                                    />
                            </div>

                            <div style={{width: '18%'}}>
                                <HorizontalTextinput 
                                    title="Start date"
                                    disabled={true}
                                    value={moment(value.startDate).subtract(10, 'days').calendar()}
                                    />
                            </div>
                            <div style={{width: '18%'}}>
                                <HorizontalTextinput 
                                    title="End date"
                                    disabled={true}
                                    value={moment(value.endDate).subtract(10, 'days').calendar()}
                                    />
                            </div>
                            <div style={{width: '18%'}}>
                                <HorizontalTextinput 
                                    title="Country"
                                    disabled={true}
                                    value={value.location?.label || value.location}/>
                            </div>
                            <div className="addition-container-circle">
                                <div className="addition-red-ctn mt-4" onClick={()=>handleRemoveItem(id)}>
                                    <span>-</span>
                                </div>
                                {/* {id === 0 && addBtn && <div className="addition-blue-ctn mt-4" onClick={()=>handleShowItems()}>
                                    <span>+</span>
                                </div>} */}
                            </div>
                    </div>
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                            <span className="general-span-text-none-auto mt-2">{value.certificateDocumentFile?.name}</span>
                            {/* <img src={`data:image/${value.certificateDocumentFile?.type};base64,${value.certificateDocumentFile?.fileText}`} style={{width: 150, height: 150}}/> */}
                            <a 
                                style={{
                                    cursor: 'pointer'
                                }}
                                onClick={()=>downloadFile(value)}
                                >download</a>
                        </div>
                    </div>
            )
        })
    }



    var certifiedAwardUrl

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    const handleNewCertificate = async ()=>{
        setHasUploaded(true)
        if(certificateName === '' && provider === '' && location === '' && startDate === '' && endDate === ''){
            return
        }
        if(newUserInfo.length > 0){
            const fileUrl = await toBase64(newUserInfo[0]).then(value=>{
                certifiedAwardUrl = value.split(',')[1]
            })
        }
        setNewCertificateArr([...newCertificateArr, {
            certificateName,
            provider,
            location,
            startDate,
            endDate,
            certificateDocumentFile:{
                fileText: certifiedAwardUrl,
                type: newUserInfo[0]?.name?.split('.')?.pop(),
                name: newUserInfo[0]?.name,
                changed: true
            }
            
        }
        ])
        setCertificateName('')
        setProvider('')
        setLocation('')
        setStartDate(null)
        setEndDate(null)
        setFiles({})
    }


    const handleSaveForLater = async ()=>{
        const reqId = uuidv4()
        setRequestId(reqId)
        if(newUserInfo.length > 0){
            const fileUrl = await toBase64(newUserInfo[0]).then(value=>{
                certifiedAwardUrl = value.split(',')[1]
            })
        }    
        var certificateArr = []
        if(certificateName !== '' && 
            provider !== '' && 
            startDate !== undefined && 
            endDate !== undefined && 
            location !== ''){
            certificateArr.push({
                certificateDocumentFile: {
                    fileText: certifiedAwardUrl,
                    type: newUserInfo[0]?.name?.split('.')?.pop(),
                    name: newUserInfo[0]?.name,
                    changed: true
                },
                endDate: endDate,
                location: location?.label,
                name: certificateName,
                provider: provider,
                startDate: startDate
            })
        }
        var incomingArr = []
        if(newCertificateArr.length > 0){
            newCertificateArr.map(value=>{
                incomingArr.push({
                    certificateDocumentFile: {
                        fileText: value.certificateDocumentFile?.certifiedAwardUrl || value.certificateDocumentFile?.fileText,
                        type: value.certificateDocumentFile?.type,
                        name: value.certificateDocumentFile?.name,
                        changed: value.certificateDocumentFile?.changed
                    },
                      endDate: value.endDate,
                      location: value.location?.label || value.location,
                      name: value.certificateName || value.name,
                      provider: value.provider,
                      startDate: value.startDate
                })
            })
        }
        Array.prototype.push.apply(certificateArr,incomingArr)

        const sendData= {
            ...applicationDetails,
            professionalCertificates:certificateArr,
            step:5,
        }
        if(isMember){
            const sentItems = {
                professionalCertificates:certificateArr,
            }
            dispatch(editMembership({
                id: appId, 
                application: sentItems,
                reqId : reqId
            }))
            return
        }
        if(applicationId){
            dispatch(updateIndividualApplication({
                data:{
                    ...sendData
                },
                id: applicationId,
                reqId : reqId
            }))
        }else{
            dispatch(submitIndividualApplication({
                data:{
                    ...sendData
                },
                reqId:reqId
            }))
        }
    }
       
    const handleSubmit = async ()=>{
        history.push({
            pathname: '/applicant/reference-details',
            state: {
                application: applicationDetails
            }
        })
        handleSaveForLater()
    }

    const handleCancel = ()=>{
        history.push({
            pathname: '/applicant/educational-details',
            state: {
                application: applicationDetails
            }
        })
     }

     const handleMembership = () =>{
        handleSaveForLater()
     }

     const handleCloseMembership = ()=>{
        history.goBack()
    }

    return (
        <div>
           { !isMember &&<DashboardHeader 
                activeStep={5}
                application={applicationDetails}/>}
            <DashBoardContainer
                handleSubmit={handleSubmit}
                handleCancel={handleCancel}
                handleSaveForLater={handleSaveForLater}
                title="Next"
                disabled={actionLoader}
                loader={actionLoader}
                middleTitle="Save for Later"
                hasCloseBtn={isMember ? true: false}
                hasButton={isMember ? true: false}
                closeTitle="Submit"
                handleClose={handleMembership}
                editLoader={apiResponse.editLoader?.isLoading}
                handleCloseMembership={handleCloseMembership}
                >
                <div className="d-flex w-100" style={{
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <div>

                    </div>
                    <span className="dashboard-green-text-header">
                        Professional certification details 
                            <span style={{
                                color: '#F1F1F1',
                                marginBottom: 20
                            }}>
                                (not mandatory)
                            </span>
                    </span>
                    <div>
                        {applicationDetails.professionalCertificates?.length > 0 && addBtn && <div className="addition-container-circle mt-4" style={{width: 80}} onClick={()=>handleShowItems()}>
                                <div className="addition-blue-ctn mt-2">
                                    <span>+</span>
                                </div>
                            </div>}
                    </div>
                </div>
                   {applicationDetails.professionalCertificates?.length <= 0 || showItems ? <div className="dashboarder-grey-contanier">
                        <div style={{width: '90%'}}>
                            <div className="d-flex">
                                <div style={{width: '20%'}}>
                                    <HorizontalTextinput 
                                        title="Certificate name"
                                        handleChange={(text)=>handleCertificateName(text)}
                                        value={certificateName}
                                        // required={true}
                                        />
                                </div>
                                <div style={{width: '20%'}}>
                                    <HorizontalTextinput 
                                        title="Provider"
                                        handleChange={handleProvider}
                                        value={provider}
                                        // required={true}
                                        />
                                </div>
                                <div style={{width: '20%'}}>
                                    <DatePicker 
                                        title="Start Date"
                                        handleDateOfBirth={handleStartdate}
                                        value={startDate}
                                        // required={true}
                                        />
                                </div>
                                <div style={{width: '20%'}}>
                                    <DatePicker 
                                        title="End date"
                                        handleDateOfBirth={handleEndDate}
                                        value={endDate}
                                        // required={true}
                                        />
                                </div>
                                <div style={{width: '20%'}}>
                                    <CountrySelector 
                                        title="Country"
                                        handleNationality={handleLocation}
                                        nationality={location}
                                        // required={true}
                                        />
                                </div>
                            </div>
                            <div style={{width: '50%', marginRight: 5, margin: 'auto'}} className="mt-4">
                                <span className="general-span-text-none-auto-small">Attach notified award received</span>
                                <DragAndDrop
                                    accept=".jpg,.png,.jpeg,.pdf"
                                    label=""
                                    multiple
                                    updateFilesCb={updateUploadedFiles}
                                    files={files}
                                    setFiles={setFiles}
                                    hasUploaded={hasUploaded}
                                    setHasUploaded={setHasUploaded}
                                    hide={true}
                                    dragText={true}
                                    showFileModel={showFileModel}

                                    />
                            </div>
                        </div>
                        <div className="addition-container-circle" onClick={handleNewCertificate}>
                            <div className="addition-blue-ctn mt-4">
                                <span>+</span>
                            </div>
                        </div>
                    </div>: null}
                    {displayNewArr}
                <PopupModel
                    show={fileModel}
                    hide={()=>showFileModel(false)}
                    content="File uploaded is too big"
                    btnText="OK"
                    handleConfirm={()=>showFileModel(false)}
                    />
            </DashBoardContainer>
        </div>
    )
}

export default ApplicationCertificationDetails